exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.remove {\n    color: #FC4B0A;\n    background: transparent;\n    border: none;\n    cursor: pointer;\n}\n.cart-container {\n    \n}\n.table button, .table a {\n    cursor: pointer;\n    color: #FC4B0A;\n    text-decoration: none;\n    background: transparent;\n    border: none;\n    padding: 0;\n    margin: 0;\n\n}\n.table button i {\n    color: #FC4B0A;\n}\nh1 {\n    font-family: 'Special Elite', cursive;\n    color: #FC4B0A;\n\n}\n.btn {\n    \n    color: #000;\n    font-family: 'Special Elite', cursive;\n    padding-top: 10px;\n}\n.btn-back {\n    background: #FC4B0A;\n\n}\n.btn-checkout {\n    background: #31a8f7;\n\n    float: right;\n\n}\ninput.form-control {\n    width: 65px;\n    max-width: 100%;\n    display: inline-block;\n}\n.fa-wrench {\n    color: #FC4B0A;\n    \n}\nimg.thanks {\n    max-width: 100%;\n    float: right;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /tmp/build_fdb7fa8d/src/app/cart/cart.component.css
// module id = ../../../../../src/app/cart/cart.component.css
// module chunks = main